import { ReactTelemetryContext,TelemetryContext } from '@tableau/data-catalog-shared';
import React from 'react';

import { SessionService } from '~src/commonInfra/services/SessionService';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { SiteRoles } from '~src/userManagement/users/serverApi/types/ISiteRole';

export function getTelemetryCommonProperties(): TelemetryContext {
  const session_id = SessionService.getSessionId();

  const sessionManagementService = getSessionManagementServiceInstance();
  const user_luid = sessionManagementService.sessionUserLuid();
  const site_luid = sessionManagementService.sessionSiteLuid();

  const is_admin = sessionManagementService.isSessionServerAdmin();
  const site_role_id = sessionManagementService.sessionSiteRoleId();
  const site_role = getSiteRoleFromSession(site_role_id, is_admin);

  return {
    session_id,
    site_role_id,
    site_role,
    site_luid,
    user_luid,
  };
}

function getSiteRoleFromSession(siteRoleId: number, isAdmin: boolean): string {
  switch (siteRoleId) {
    case 0:
      return SiteRoles.SiteAdministratorExplorer;
    case 1:
      return SiteRoles.SupportUser;
    case 2:
      return SiteRoles.ExplorerCanPublish;
    case 3:
      return SiteRoles.Explorer;
    case 7:
      return SiteRoles.Guest;
    case 8:
      return SiteRoles.Unlicensed;
    case 9:
      return SiteRoles.Viewer;
    case 10:
      return isAdmin ? SiteRoles.ServerAdministrator : SiteRoles.Creator;
    case 11:
      return SiteRoles.SiteAdministratorCreator;
    default:
      return 'Unknown-User-Role';
  }
}

export function CatalogTelemetryProvider(props: { readonly children: JSX.Element }): JSX.Element {
  return (<ReactTelemetryContext.Provider value={getTelemetryCommonProperties()}>{props.children}</ReactTelemetryContext.Provider>);
}
